export default __webpack_public_path__ + "static/media/UnionRed.f84c8830.svg";